import { LinkedUserList } from "./components/LinkedUserList";

export default LinkedUserList;